<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <div *ngIf="loadedOptions$ | async as allRadioButtonOptions" class="lv-radio-group-items"
         [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
      <ng-container *ngIf="!!allRadioButtonOptions && !!allRadioButtonOptions.length">
        <lv-label-tooltip class="lv-label-tooltip" [label]="uiArtefakt.Text"
                          [labelSymbol]="nestedSymbol"
                          [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                          [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                          [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                          (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
        <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                          [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
        <div class="lv-radio-group">
          <mat-radio-group [ngClass]="{'lv-material-segment-control-kachel': true, 'lv-segment-flex-size': true}" #radioGroup="ngModel"
                           [(ngModel)]="uiArtefakt.WertEingabe"
                           [required]="uiArtefakt.PflichtfeldJN"
                           [name]="controlName" [id]="uniqueId"
                           [disabled]="isDisabled">
            <mat-radio-button
                [ngClass]="{'lv-radio-button-inline': isRadioGroupInline, 'lv-error-state': !!getError()}"
                *ngFor="let element of allRadioButtonOptions"
                [value]="element.WertEingabe"
                (change)="changeSelection(element.WertEingabe)"
                [checked]="('' + uiArtefakt.WertEingabe === '' + element.WertEingabe)">
              <span [innerHTML]="element.WertAnzeige"></span>
            </mat-radio-button>
            <mat-error *ngIf="getError() as error" class="lv-error-meldung-style" [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}"
                       (click)="onErrorClick()">
              {{error}}
            </mat-error>
          </mat-radio-group>
          <lv-infotext-permanent
              [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
        </div>
      </ng-container>
    </div>
  </div>
</form>
